var req = require("!!/Users/eugene/Work/tabby/node_modules/pug-loader/index.js??ruleSet[1].rules[3].use[1]!/Users/eugene/Work/tabby/tabby-core/src/directives/dropZone.directive.pug");
module.exports = (req['default'] || req).apply(req, [])